'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './profile.routes';
import params from 'angular-ui-router';
import uiBootstrap from 'angular-ui-bootstrap';

export class CreateSandboxController{
  constructor($scope, $cookies, $http, $rootScope, $window, user) {
    const email = $cookies.get('email');
    const that = this;
    this.user = user;
    this.creationFailed = false;
    this.creationSucceeded = false;
    this.weekPassword = false;
    this.strongPassword = false;
    this.fairPassword = false;
    this.password = '';
    this.passwordConfirmation = '';
    this.passwordMismatch = false;
    this.apiDevEmail = '';
    this.continue = function(){
      $http.post('/api/oauth/create-sandbox', {
        email: email,
        password: that.password
      }).then(function(response) {
            that.creationSucceeded = true;
            that.creationFailed = false;            
            $rootScope.sandBoxJustCreated = true;
            window.location.reload();
        }, function(response) {          
            that.creationSucceeded = false;
            that.creationFailed = true;
            console.log(`Sandbox account creation failed: [${response.status}] ${response.data}`);
        });
    };

    if(email && email.indexOf('@') > 0){
      const parts = email.split('@');
      this.apiDevEmail = `${parts[0]}-apidev@${parts[1]}`;
    }

    $scope.$watch('$ctrl.password', function(oldValue, newValue){
        that.weekPassword = false;
        that.strongPassword = false;
        that.fairPassword = false;

        if(newValue.length === 0){            
            return;
        }

        if(newValue.length < 8){
            that.weekPassword = true;            
            return;
        }

        if(/^[a-zA-Z0-9- ]*$/.test(newValue)) {            
            that.fairPassword = true;
            return;
        }
        that.strongPassword = true;
        that.passwordMismatch = newValue !== that.passwordConfirmation;
    });

    $scope.$watch('$ctrl.passwordConfirmation', function(oldValue, newValue){
        that.passwordMismatch == false;
        if(newValue.length === 0){            
            return;
        }

        that.passwordMismatch = that.passwordConfirmation !== that.password;
    });
  }
}

CreateSandboxController.$inject = ['$scope', '$cookies', '$http', '$rootScope', '$window', 'user'];

export class ProfileComponent {
  constructor($scope, $http, $window, $cookies, $uibModal, $rootScope) {
    this.uibModal = $uibModal;
    $scope.loading = true;    
    $http.get('/api/oauth/info').then(function(response) {
            $scope.user = response.data;
            $scope.loading = false;
        }, function(response) {
            console.log(`User information retirival failed: [${response.status}] ${response.data}`);
            $scope.loading = false;
        });

    $scope.isSandboxAllowed = () => $scope.user && $scope.user.axwayUser && (!$scope.user.axwayUser.allowSandboxCreation || $scope.user.axwayUser.allowSandboxCreation !== 'false');    
    $scope.createSandbox = () => {
      var modalInstance = $uibModal.open({                      
              template: require('./profile.sandbox.html'),
              controller: CreateSandboxController,
              animation: true,
              controllerAs: '$ctrl',
              keyboard: true,
              size: 'md',
              resolve: {
                  user: $scope.user
              }
          });
    };
  }
}

ProfileComponent.$inject = ['$scope', '$http', '$window', '$cookies', '$uibModal', '$rootScope'];

export default angular.module('syncplicityLoginApp.profile', [uiRouter])
  .config(routes)
  .component('profile', {
    template: require('./profile.html'),
    controller: ProfileComponent,
    controllerAs: 'profileCtrl'
  })
  .name;


// WEBPACK FOOTER //
// ./client/app/profile/profile.component.js